export default __webpack_public_path__ + "static/media/redsky.c0908d66.jpg";